<template>
  <div class="duty-edit">
    <el-dialog title="修改编排" :visible="editDutyShow" @open="dialogOpen" @close="dialogClose"
      :close-on-click-modal="false" width="600px" center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="编排名称:" prop="dutyName" label-width="100px">
          <el-input v-model="ruleForm.dutyName" placeholder="请输入编排名称"></el-input>
        </el-form-item>
        <el-form-item label="学年:" prop="schoolYearVal" label-width="100px">
          <!-- <el-date-picker v-model="ruleForm.schoolYearVal" type="year" placeholder="学年">
          </el-date-picker> -->
          <year-range-picker style="width: 250px;" v-model="ruleForm.schoolYearVal" />
        </el-form-item>
        <el-form-item label="学期:" prop="semesterVal" label-width="100px">
          <el-select v-model="ruleForm.semesterVal" placeholder="学期" clearable>
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="值日时间:" prop="date" required>
          <el-date-picker
            v-model="ruleForm.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker
        ></el-form-item> -->
        <el-form-item label="编排说明:" prop="notice" label-width="100px">
          <el-input type="textarea" v-model="ruleForm.notice" :rows="10"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="confirm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["editDutyShow", "dutyInfo", "semesterOptions"],
  data() {
    return {
      ruleForm: {
        dutyName: "", // 名称
        date: "", // 时间
        notice: "", // 说明
        schoolYearVal: "",
        semesterVal: "",
        // startDate: "", // 开始日期
        // endDate: "", // 结束日期
      },
      rules: {
        dutyName: [
          { required: true, message: "请输入编排名称", trigger: "blur" },
        ],
        // notice: [
        //   { required: true, message: "请输入编排说明", trigger: "blur" },
        // ],
        schoolYearVal: [
          { required: true, message: "请选择学年", trigger: "change" },
        ],
        semesterVal: [
          { required: true, message: "请选择学期", trigger: "change" },
        ],
      },
      pickerMinDate: null, // 限制选择日期
      pickerOptions: {
        // 限制选择日期范围为一周
        disabledDate: (time) => {
          // 如何选择了一个日期
          if (this.pickerMinDate) {
            // 7天的时间戳
            const one = 6 * 24 * 3600 * 1000;
            // 当前日期 - one = 7天之前
            const minTime = this.pickerMinDate - one;
            // 当前日期 + one = 7天之后
            const maxTime = this.pickerMinDate + one;
            return (
              time.getTime() < minTime || time.getTime() > maxTime
              // 限制不能选择今天及以后
              // || time.getTime() + 1 * 24 * 3600 * 1000 > Date.now()
            );
          } else {
            // 如果没有选择日期，就要限制不能选择今天及以后
            // return time.getTime() + 1 * 24 * 3600 * 1000 > Date.now();
          }
        },
        onPick: ({ maxDate, minDate }) => {
          // 把选择的第一个日期赋值给一个变量。
          this.pickerMinDate = minDate.getTime();
          // 如何你选择了两个日期了，就把那个变量置空
          if (maxDate) this.pickerMinDate = null;
        },
      },
    };
  },
  inject: ["refresh"],
  methods: {
    dialogOpen() {
      this.ruleForm.dutyName = this.dutyInfo.dutyName;
      this.ruleForm.schoolYearVal = this.dutyInfo.schoolYear;
      this.ruleForm.semesterVal = this.dutyInfo.semester;
      this.ruleForm.notice = this.dutyInfo.notice.replace(/<br\/>/g, "\n");
      this.ruleForm.date = [this.dutyInfo.startDate, this.dutyInfo.endDate];
    },
    dialogClose() {
      this.$emit("update:editDutyShow", false);
    },
    confirm(formName) {
      // 验证表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { dutyName, startDate, endDate, notice, date, schoolYearVal, semesterVal } = this.ruleForm;
          startDate = date[0];
          endDate = date[1];
          notice = notice.replace(/\n/g, "<br/>");

          let submit = {
            dutyName,
            // startDate,
            // endDate,
            schoolYear: typeof schoolYearVal == 'string' ? schoolYearVal : schoolYearVal.getFullYear(),
            semester: semesterVal,
            notice,
            id: this.dutyInfo.id,
            schoolId: this.user.schoolId,
          };

          // 修改值日时间
          this.put(this.$url.updateDuty, submit)
            .then((res) => {
              if (res.code == 200) {
                this.$message.success("修改成功");
                // 刷新列表
                this.refresh();
                // 关闭弹出框
                this.dialogClose();
              } else {
                this.$message.warning(res.msg);
              }
            })
            .catch((err) => {
              this.$message.error("修改失败，请稍后再试");
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./duty-edit.scss";
</style>